var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwiftProdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SWIFTProdLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(-596.604 -552.489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(596.604 552.489)",
    fill: "#1e4965"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_45717ba9917d06a8da6c10f1fdee6b59",
    "data-name": "45717ba9917d06a8da6c10f1fdee6b59",
    transform: "translate(-40.415 320.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M72.515-311.454a28.75,28.75,0,0,0-23.238,24.075c-.893,6.249.753,14.255,3.933,18.83l.865,1.283H59.71c5.635,0,5.635,0,6.723.725a22.169,22.169,0,0,0,6.333,2.734,25.515,25.515,0,0,0,9.429,0,20.35,20.35,0,0,0,13.223-10.517,17.592,17.592,0,0,0,2.064-8.09l.167-2.985H89.309l-.5-1.7a13.3,13.3,0,0,0-3.878-5.635,17.37,17.37,0,0,0-4.742-2.315l-.781-.167.084,2.036.084,2.064,1.116.5a9.175,9.175,0,0,1,3.822,3.682,8.077,8.077,0,0,1,.725,3.152,5.523,5.523,0,0,1-.781,3.85,7.667,7.667,0,0,1-3.906,3.822c-1,.474-1.116.7-1.116,2.622,0,1.674.028,1.758.67,1.758,1.227,0,4.491-1.9,5.942-3.431a11.079,11.079,0,0,0,2.873-4.854c.391-1.311.53-1.367,2.845-1.255,1.869.112,1.785-.2.753,3.124-1.479,4.8-6.221,9.094-11.41,10.35a17.412,17.412,0,0,1-12.135-2.036,18.67,18.67,0,0,1-5.412-5.775l-.893-1.7H58.231l.586,1.451a22.029,22.029,0,0,0,1.395,2.818,10.446,10.446,0,0,1,.809,1.451,10.742,10.742,0,0,1-2.483.139H56.083l-.893-1.981a26.229,26.229,0,0,1-1.7-14.618,24.892,24.892,0,0,1,15.148-18.105,25.121,25.121,0,0,1,21.732,2.009c.921.586,1.311.614,4.185.558l3.152-.084-2.371-1.869A28.592,28.592,0,0,0,72.515-311.454Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M94.473-281.427a21.94,21.94,0,0,0-11.187,6.807,19.476,19.476,0,0,0-4.519,11.912l-.139,3.152h8.341l.474,1.451a12.32,12.32,0,0,0,7.114,7.56c2.148.837,2.288.753,2.288-1.479V-254l-1.116-.5a7.991,7.991,0,0,1-4.268-9.959,9,9,0,0,1,4.352-4.547l1.032-.363v-4.185l-.893.2c-3.906.837-8.034,4.966-8.76,8.7l-.167.921H82.9l.139-.781a20.334,20.334,0,0,1,2.79-6.416c5.942-8.062,17.017-9.039,24.019-2.148a21.121,21.121,0,0,1,2.9,3.543l.893,1.618h4.408l-.446-1.06c-.251-.558-.5-1.227-.614-1.451a13.991,13.991,0,0,0-.949-1.7,8.706,8.706,0,0,1-.781-1.479,8.955,8.955,0,0,1,2.371-.167H120l.809,1.618a24.493,24.493,0,0,1,1.395,17.24,22.52,22.52,0,0,1-5.942,10.127,24.145,24.145,0,0,1-11.466,6.751,19.22,19.22,0,0,1-6,.614,20.882,20.882,0,0,1-11.3-2.734L84.43-241.7H78.6l.948.976c2.483,2.539,7.727,5.44,12,6.612,2.092.558,2.985.642,7.393.614,4.24,0,5.356-.112,7.2-.614a29.539,29.539,0,0,0,18.886-16.431,24.006,24.006,0,0,0,2.092-10.963c0-5.551-.642-8.481-2.9-12.972l-1.562-3.069-5.858-.139c-5.551-.139-5.914-.167-6.751-.781C106.051-281.315,99.746-282.515,94.473-281.427Z",
    transform: "translate(-21.317 -21.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M139.176-222.47a3.434,3.434,0,0,0-1.7,2.678,3.729,3.729,0,0,0,5.273,3.878,3.58,3.58,0,0,0,2.092-3.571,2.555,2.555,0,0,0-1.088-2.427A2.555,2.555,0,0,0,141.324-223,4.006,4.006,0,0,0,139.176-222.47Z",
    transform: "translate(-63.733 -64.073)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftProdLogo);
export default __webpack_public_path__ + "static/media/SWIFTProdLogo.6442be6c7ef3c7d6c0238b76ab300394.svg";
export { ForwardRef as ReactComponent };